import * as React from 'react';

const GoogleMap = ({height}) => {
    return (
        <iframe
            title="Manufaktura Zdrowych Stóp - lokalizacja"
            width="100%"
            height={height}
            style={{border:0}}
            loading="lazy"
            allowFullScreen
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAaz5hk8bkxhowp-HT6gkfl6Qxpe0e34yo&q=place_id:ChIJoVCaxV6JF0cR33JID6TnAc8">
        </iframe>
    )
}
export default GoogleMap